import { useCallback, useState } from 'react';
import { IconButton, Paper, Popover } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

export const HelpViewer = ({ children }: any) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const showPopover = useCallback((event: any) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const hidePopover = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton size="small" onClick={showPopover}>
        <HelpOutline />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={hidePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Paper sx={{ padding: 1 }}>{children}</Paper>
      </Popover>
    </>
  );
};
